import { createStore } from 'vuex'

import provinces from '@/store/modules/provinces'
import bubbles from '@/store/modules/bubbles'
import families from '@/store/modules/families'
import family from '@/store/modules/family'
import donor from '@/store/modules/donor'
import jsonLangs from '@/store/modules/jsonLangs'
import player from '@/store/modules/player'

const store = createStore({
  modules: {
    provinces,
    bubbles,
    families,
    family,
    donor,
    jsonLangs,
    player
  }
})

export default store
